import { css } from '@emotion/react'
import AdjustIcon from '@mui/icons-material/Adjust'
import DoneOutlineIcon from '@mui/icons-material/DoneOutline'
import StorageIcon from '@mui/icons-material/Storage'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import PropTypes from 'prop-types'
import {
  COLUMN_PROCESSOR_FINISHED,
  DATASET_INDEXING_STARTED,
  SUBMISSION_PHASE_CHANGED,
} from '../../global/constants/datasetSubmissionEventType'

const row = css`
  display: flex;
  align-items: center;
  min-height: 48px;
`

const colLeft = css`
  width: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const colMiddle = css`
  flex: 1;
`

const colRight = css`
  width: 128px;
`

const message = css`
  font-weight: 300;
  font-size: 12px;
`

const entryIconCss = css`
  color: #ddd;
`

const ENTRY_ICONS = {
  // [COLUMN_PROCESSOR_STARTED] : TimerIcon,
  // [COLUMN_PROCESSOR_PROGRESS] : TimerIcon,
  [COLUMN_PROCESSOR_FINISHED]: DoneOutlineIcon,
  // [SUBMISSION_STARTED] : TimerIcon,
  [SUBMISSION_PHASE_CHANGED]: AdjustIcon,
  [DATASET_INDEXING_STARTED]: StorageIcon,
}

export function EventLogEntry({ entry }) {
  const EntryIcon = ENTRY_ICONS[entry.type]
  return (
    <div css={row}>
      <div css={colLeft}>{EntryIcon && <EntryIcon css={entryIconCss} />}</div>

      <div css={colMiddle}>
        <Typography css={message}>{entry.message}</Typography>
      </div>

      <div css={colRight}>
        <Typography css={message}>{moment(entry.createdAt).format('h:mm:ss.SSS a')}</Typography>
      </div>
    </div>
  )
}

EventLogEntry.propTypes = {
  entry: PropTypes.shape({
    type: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
}
